import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function FacebookColourSmall(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fill: "#1877F2",
    d: "M20 10c0-5.523-4.476-10-10-10C4.477 0 0 4.477 0 10c0 4.992 3.656 9.129 8.438 9.879v-6.988h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.261c-1.243 0-1.63.772-1.63 1.563V10h2.774l-.443 2.89h-2.33v6.989C16.343 19.129 20 14.992 20 10z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M13.893 12.89l.443-2.89h-2.774V8.125c0-.791.387-1.562 1.63-1.562h1.261V4.102s-1.144-.196-2.238-.196c-2.285 0-3.777 1.385-3.777 3.89V10h-2.54v2.89h2.54v6.989a10.058 10.058 0 003.124 0v-6.988h2.33z"
  }));
}

export default FacebookColourSmall;
//# sourceMappingURL=FacebookColourSmall.js.map